import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=146a3929&scoped=true"
import script from "./Create.ts?vue&type=script&lang=ts&external"
export * from "./Create.ts?vue&type=script&lang=ts&external"
import style0 from "./Create.vue?vue&type=style&index=0&id=146a3929&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146a3929",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('146a3929')) {
      api.createRecord('146a3929', component.options)
    } else {
      api.reload('146a3929', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=146a3929&scoped=true", function () {
      api.rerender('146a3929', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/NoContract/pages/Create/Create.vue"
export default component.exports